module.exports = __webpack_public_path__ + "img/schedule-live.ece542a0.svg";